import React from "react";

import { BlockWrapper, IntroBlock } from "components/Block";
import { Container } from "components/Grid";
import List, { ListItem } from "components/List";

const Resources = ({ content }) => {
  return (
    <Container bg="white">
      <BlockWrapper pb={["50px", "120px"]}>
        <IntroBlock content={content} />
        <List>
          {content.items.map((item, index) => (
            <ListItem key={index} content={item} />
          ))}
        </List>
      </BlockWrapper>
    </Container>
  );
};

export default Resources;
